import { RouterView } from 'vue-router'
import i18n from '@/i18n/i18n'
import {
  packGoRouteGuard,
  packGoQueueRouteGuard,
  packGoConnectRouteGuard,
  packGoIntroRouteGuard,
  newPackGoRouteGuard,
  newPackGoIntroRouteGuard,
  newPackGoQueueRouteGuard,
  newPackGoBrowserNotSupportedRouteGuard,
  newPackGoPrintClientNotInstalledRouteGuard,
} from '@/router/guards/packgo-guards.js'

import {
  PACKGO_INTRO_ROUTE,
  PACKGO_INTRO_WELCOME_ROUTE,
  PACKGO_INTRO_WORKFLOWS_ROUTE,
  PACKGO_CONNECT_ROUTE,
  PACKGO_QUEUE_ROUTE,
  NEW_PACKGO_INTRO_ROUTE,
  NEW_PACKGO_QUEUE_ROUTE,
  NEW_PACKGO_BROWSER_NOT_SUPPORTED,
  NEW_PACKGO_PRINT_CLIENT_NOT_INSTALLED,
} from './packgo.routes.names.js'

export default [
  {
    name: 'packgo',
    path: '/packgo',
    beforeEnter: packGoRouteGuard,
    redirect: { name: PACKGO_INTRO_ROUTE },
    component: RouterView,
    children: [
      {
        name: PACKGO_INTRO_ROUTE,
        path: '/packgo/intro',
        beforeEnter: packGoIntroRouteGuard,
        redirect: { name: PACKGO_INTRO_WELCOME_ROUTE },
        component: RouterView,
        children: [
          {
            name: PACKGO_INTRO_WELCOME_ROUTE,
            path: '/packgo/intro/welcome',
            component: () => import('@/app/packgo/old/views/PackGoWelcome.vue'),
            meta: {
              pageTitle: () => i18n.t('Welcome to Pack & Go'),
              permissions: ['process_orders'],
            },
          },
          {
            name: PACKGO_INTRO_WORKFLOWS_ROUTE,
            path: '/packgo/intro/workflows',
            component: () => import('@/app/packgo/old/views/PackGoIntroMode.vue'),
            meta: {
              pageTitle: () => i18n.t('Welcome to Pack & Go'),
              permissions: ['process_orders'],
            },
          },
        ],
      },
      {
        name: PACKGO_CONNECT_ROUTE,
        path: '/packgo/connect',
        beforeEnter: packGoConnectRouteGuard,
        component: () => import('@/app/packgo/old/views/PackGoConnect.vue'),
        meta: {
          pageTitle: () => i18n.t('Pack & Go'),
          permissions: ['process_orders'],
        },
      },
      {
        name: PACKGO_QUEUE_ROUTE,
        path: '/packgo/queue',
        props: route => ({
          searchQuery: route.query.q,
        }),
        beforeEnter: packGoQueueRouteGuard,
        component: () => import('@/app/packgo/old/views/PackGoOrderQueue.vue'),
        meta: {
          pageTitle: () => i18n.t('Pack & Go'),
          permissions: ['process_orders'],
        },
      },
    ],
  },
  // New Pack & Go routes
  {
    name: 'new-packgo',
    path: '/new-packgo',
    beforeEnter: newPackGoRouteGuard,
    redirect: { name: NEW_PACKGO_INTRO_ROUTE },
    component: RouterView,
    children: [
      {
        name: NEW_PACKGO_INTRO_ROUTE,
        path: '/new-packgo/intro',
        beforeEnter: newPackGoIntroRouteGuard,
        // redirect: { name: NEW_PACKGO_INTRO_WELCOME_ROUTE },
        meta: {
          pageTitle: () => i18n.t('Pack & Go'),
          permissions: ['process_orders'],
        },
        component: RouterView,
        children: [
          // commented out as we don't have the onboarding ready yet
          // {
          //   name: NEW_PACKGO_INTRO_WELCOME_ROUTE,
          //   path: '/new-packgo/intro/welcome',
          //   beforeEnter: newPackGoIntroWelcomeRouteGuard,
          //   component: () => import('@/app/packgo/new/views/NewPackGoOrderQueue.vue'),
          //   meta: {
          //     pageTitle: () => i18n.t('Pack & Go'),
          //   },
          // },
          // {
          //   name: NEW_PACKGO_INTRO_DOWNLOAD_ROUTE,
          //   path: '/new-packgo/intro/download',
          //   beforeEnter: newPackGoDownloadOrSettingsRouteGuard,
          //   component: () => import('@/app/packgo/new/views/NewPackGoOrderQueue.vue'),
          //   meta: {
          //     pageTitle: () => i18n.t('Pack & Go'),
          //   },
          // },
          // {
          //   name: NEW_PACKGO_INTRO_SETTINGS_ROUTE,
          //   path: '/new-packgo/intro/settings',
          //   beforeEnter: newPackGoDownloadOrSettingsRouteGuard,
          //   component: () => import('@/app/packgo/new/views/NewPackGoOrderQueue.vue'),
          //   meta: {
          //     pageTitle: () => i18n.t('Pack & Go'),
          //   },
          // },
        ],
      },
      {
        name: NEW_PACKGO_QUEUE_ROUTE,
        path: '/new-packgo/queue',
        component: () => import('@/app/packgo/new/views/NewPackGoOrderQueue.vue'),
        beforeEnter: newPackGoQueueRouteGuard,
        meta: {
          pageTitle: () => i18n.t('Pack & Go'),
          permissions: ['process_orders'],
        },
      },
      {
        name: NEW_PACKGO_BROWSER_NOT_SUPPORTED,
        path: '/new-packgo/browser-not-supported',
        component: () => import('@/app/packgo/new/views/NewPackGoBrowserNotSupported.vue'),
        beforeEnter: newPackGoBrowserNotSupportedRouteGuard,
        meta: {
          pageTitle: () => i18n.t('Pack & Go'),
          permissions: ['process_orders'],
        },
      },
      {
        name: NEW_PACKGO_PRINT_CLIENT_NOT_INSTALLED,
        path: '/new-packgo/print-client-not-installed',
        component: () => import('@/app/packgo/new/views/NewPackGoPrintClientNotInstalled.vue'),
        beforeEnter: newPackGoPrintClientNotInstalledRouteGuard,
        meta: {
          pageTitle: () => i18n.t('Pack & Go'),
          permissions: ['process_orders'],
        },
      },
    ],
  },
]
